import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const ImageBlock = ({
  image = '',
  caption = '',
  altText = '',
  width = '100%',
  maxWidth = '800px',
  align = 'center',
  padding = '1rem'
}) => {
  console.log('Rendering ImageBlock component with props:', { image, caption });
  
  return (
    <Box
      sx={{
        width: '100%',
        padding,
        textAlign: align
      }}
    >
      <Container maxWidth="lg" sx={{ maxWidth }}>
        {image && (
          <Box
            component="img"
            src={image}
            alt={altText || caption}
            sx={{
              width: width,
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
              marginLeft: align === 'center' ? 'auto' : align === 'right' ? 'auto' : '0',
              marginRight: align === 'center' ? 'auto' : align === 'left' ? 'auto' : '0',
            }}
          />
        )}
        {caption && (
          <Typography 
            variant="body2" 
            sx={{ 
              mt: 1, 
              fontStyle: 'italic',
              textAlign: align
            }}
          >
            {caption}
          </Typography>
        )}
      </Container>
    </Box>
  );
};

// Define the fields for the Puck editor
ImageBlock.fields = {
  image: {
    type: 'text',
    label: 'Image URL',
    default: ''
  },
  caption: {
    type: 'text',
    label: 'Caption',
    default: ''
  },
  altText: {
    type: 'text',
    label: 'Alt Text',
    default: ''
  },
  width: {
    type: 'text',
    label: 'Width',
    default: '100%'
  },
  maxWidth: {
    type: 'text',
    label: 'Max Width',
    default: '800px'
  },
  align: {
    type: 'select',
    label: 'Alignment',
    options: [
      { label: 'Left', value: 'left' },
      { label: 'Center', value: 'center' },
      { label: 'Right', value: 'right' }
    ],
    default: 'center'
  },
  padding: {
    type: 'text',
    label: 'Padding',
    default: '1rem'
  }
};

export default ImageBlock; 